import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const BioDetailsContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
    row-gap: 5px;
`;

export const Label = styled.b`
    ${BaseStyle.Mixins.fontStyles.ui['14b']}
`;

export const SocialLinksContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14m']}
`;

export const PlayerInfo = styled.div`
    display: grid;
    margin-top: 18px;
    row-gap: 5px;
    grid-template-columns: 1fr;

    ${BaseStyle.Mixins.screenSizes.medium} {
        grid-template-columns: 1fr 1fr;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        grid-template-columns: 1fr;
    }
`;
